import {Component} from '@angular/core';
import {Game} from '../../../domain/game';
import {GameManagementService} from '../game-management.service';

@Component({
  templateUrl: './management.component.html'
})
export class ManagementComponent {

  games: Game[];
  authCode: string;
  errorTextInComponent = '';

  constructor(
    private gameManagementService: GameManagementService) {
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.key;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  checkAuthCode(code) {
    this.errorTextInComponent = '';
    this.gameManagementService.getGames(code).subscribe(games => {
      this.games = games;
    }, error => {
      this.errorTextInComponent = error;
    });
  }
}
